import React, { Component } from "react";
import styles from "../OrderDetailsNewVersion.module.scss";
import { withTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import crStyles from "../../../customerReservation/crStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import { InfoDetail } from "../InfoDetail";
import { AGENT } from "../../../../utils/EmpUtil";
class DealerInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandDealerInfo: false,
    };
  }

  expandDealerInfo = () => {
    this.setState((prevState) => ({
      expandDealerInfo: !prevState.expandDealerInfo,
    }));
  };

  render() {
    const { dealerInfos } = this.props;
    const dealerType = this.props.dealerType;

    return (
      <StyledBasicExpansionPanel
        defaultExpanded={false}
        onChange={() => this.expandDealerInfo()}
      >
        <StyledBasicExpansionPanelSummary
          style={crStyles.orderDetailsExpansion}
          id="exp"
        >
          <div className={styles.headerBar}>
            <div className={styles.headerMargin}>
              <span className={styles.boldHeader}>
                {dealerType === AGENT
                  ? this.props.t("AgentInfo.agentInformation")
                  : this.props.t("DealerInfo.dealerInformation")}
              </span>
            </div>
            {this.state.expandDealerInfo ? (
              <ExpandLessIcon id="less" />
            ) : (
              <ExpandMoreIcon id="more" />
            )}
          </div>
        </StyledBasicExpansionPanelSummary>
        <div className={styles.customerInfoGrid}>
          <div className={styles.bottomBorder} />
          <Grid container className={styles.customerContainer}>
            {dealerInfos ? (
              dealerInfos.map((dealerInfo) => (
                <Grid item xs={3}>
                  <div className={styles.subHeaderText}>
                    {dealerInfo.isCollectionPointDealer
                      ? "Collection Dealer"
                      : dealerType === AGENT
                      ? this.props.t("AgentInfo.agentDetails")
                      : this.props.t("DealerInfo.dealerDetails")}
                  </div>
                  <InfoDetail
                    header={
                      dealerType === AGENT
                        ? this.props.t("AgentInfo.agentName")
                        : this.props.t("DealerInfo.dealerName")
                    }
                    value={dealerInfo.name}
                  />
                  <>
                    <div className={styles.itemHeaderText}>
                      {dealerType === AGENT
                        ? this.props.t("AgentInfo.agentAddress")
                        : this.props.t("DealerInfo.dealerAddress")}
                    </div>

                    <div
                      className={`${styles.smallHeaderMargin} ${styles.customerInfoContainer}`}
                    >
                      <div className={styles.customerInfoTextBold}>
                        {dealerInfo.addressLine1}
                      </div>
                      <div className={styles.customerInfoTextBold}>
                        {dealerInfo.addressLine2}
                      </div>
                    </div>
                  </>
                  <InfoDetail
                    header={
                      dealerType === AGENT
                        ? this.props.t("AgentInfo.agentPhone")
                        : this.props.t("DealerInfo.dealerPhone")
                    }
                    value={dealerInfo.phone}
                  />
                  {this.props.isNAMarket ? (
                    <>
                      <InfoDetail
                        header={this.props.t("DealerInfo.dealerPACode")}
                        value={dealerInfo.paCode}
                      />
                      <InfoDetail
                        header={this.props.t("DealerInfo.dealerSalesCode")}
                        value={dealerInfo.salesCode}
                      />
                    </>
                  ) : (
                    <InfoDetail
                      header={
                        dealerType === AGENT
                          ? this.props.t("AgentInfo.agentId")
                          : this.props.t("DealerInfo.dealerId")
                      }
                      value={dealerInfo.dealerId}
                    />
                  )}
                </Grid>
              ))
            ) : (
              <span className={styles.labelError}>
                {" "}
                {this.props.t("CustomerOrderDetails.errorLoadingCustomerInfo")}
              </span>
            )}
          </Grid>
        </div>
      </StyledBasicExpansionPanel>
    );
  }
}

export default withTranslation("emp")(DealerInformation);
